import { Badge, BadgeSize, BadgeVariant } from "@/components/ui/Badge";
import { BasicTooltip } from "@/components/ui/Tooltip";

/**
 * Small pill shown on the request log detail page when a log was ingested
 * before this workspace ever set a retention policy. It explains why the record
 * is still visible even though a retention policy is now enabled.
 */
export const RetentionPolicyBadge = ({
  loggedBeforeRetentionPolicy,
}: {
  loggedBeforeRetentionPolicy?: boolean | null;
}) => {
  if (!loggedBeforeRetentionPolicy) {
    return null;
  }

  return (
    <BasicTooltip content="Logged before this workspace set a retention policy, so it's kept even though a retention policy is now enabled.">
      <Badge
        variant={BadgeVariant.AMBER}
        size={BadgeSize.SM}
        showDot
        text="Before retention policy"
        className="cursor-default"
      />
    </BasicTooltip>
  );
};
